/** save the given data to the browser's download folder, with an optional mimetype */
export function download(filename: string, data: string | ArrayBuffer, type?: string) {
  const file = new Blob([data], { type });
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
}
